@if (showNewDashboardModal) {
  <app-lex-xi-modal
    [isVisible]="showNewDashboardModal"
    maxWidth="660px"
    (close)="onNewDashboardModalClosed(null)"
  >
    <ng-template appXIModalContent>
      <app-new-dashboard
        [data]="newDashboardModalData"
        (modalClosed)="onNewDashboardModalClosed($event)"
      ></app-new-dashboard>
    </ng-template>
  </app-lex-xi-modal>
}
